import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';

const PlaybookSync = (props) => {
  const playbooks = props.playbooks;
  const playbooksLoadData = props.playbooksLoadData;

  React.useEffect(() => {
    const checkPlaybooks = async () => {
      if (!playbooks.lastLoadTime) {
        try {
          const loadedPlaybooks = await backend.playbook.list();

          playbooksLoadData(loadedPlaybooks?.list || []);
        } catch (error) {
          console.error('Error fetching playbooks:', error);
        }
      }
    };

    checkPlaybooks();
  }, [playbooks.lastLoadTime, playbooksLoadData]);

  return null;
};

PlaybookSync.propTypes = {
  playbooks: PropTypes.object.isRequired,
  playbooksLoadData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  playbooks: state.playbooks,
});

export default connect(mapStateToProps, dispatch)(React.memo(PlaybookSync));
